import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Archive from './pages/Archive';
import About from './pages/About';
import ArticleDetail from './pages/ArticleDetail';
import Subscribe from './pages/Subscribe';
import SubmitArticle from './pages/SubmitArticle';
import Unsubscribe from './pages/Unsubscribe';
import './index.css';
import './styles/loading.css';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import Articles from './pages/admin/Articles';
import Feedback from './pages/admin/Feedback';
import AdminNewsletterPreview from './pages/admin/AdminNewsletterPreview';
import AdminUserManagement from './pages/admin/AdminUserManagement';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/about" element={<About />} />
        <Route path="/article/:slug" element={<ArticleDetail />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/submit" element={<SubmitArticle />} />
        <Route path="/unsubscribe/:email" element={<Unsubscribe />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <AdminProtectedRoute>
              <Dashboard />
            </AdminProtectedRoute>
          } 
        />
        <Route 
          path="/admin/articles" 
          element={
            <AdminProtectedRoute>
              <Articles />
            </AdminProtectedRoute>
          } 
        />
        <Route 
          path="/admin/feedback" 
          element={
            <AdminProtectedRoute>
              <Feedback />
            </AdminProtectedRoute>
          } 
        />
        <Route 
          path="/admin/newsletter-preview" 
          element={
            <AdminProtectedRoute>
              <AdminNewsletterPreview />
            </AdminProtectedRoute>
          } 
        />
        <Route path="/admin/user-management" element={<AdminProtectedRoute><AdminUserManagement /></AdminProtectedRoute>} />
        <Route path="*" element={<div className="container section"><h1>Page Not Found</h1></div>} />
      </Routes>
    </Router>
  );
}

export default App;
